import React, { useState, useContext, useEffect } from "react";
import { SimpleForm } from "simple-ui-components";

import CheckIcon from "@mui/icons-material/Check";
import FilterListOutlinedIcon from "@mui/icons-material/FilterListOutlined";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";

import {
  BodyWrapperStyled,
  BoxStyled,
  CardStyled,
  CardHeader,
  CardBody,
} from "../../theme";
import { AccountDetail } from "../accounts/accountDetail";
import { AuthContext } from "../authContextProvider";
import { post, del, get } from "../../server-requests/serverRequests";
import { getTranslation } from "../languageProvider";
import { Log, ReplaceWord } from "../shared/utility";
import { InProgress } from "../shared/loading";
import { useWindowSize } from "../layout/otherPage";

const filterSelectedTechnician = (full, selected) => {
  let listToReturn = [];
  for (let technician of full) {
    let isExist = selected.some((item) => item.account.id === technician.id);
    if (!isExist) {
      listToReturn = [...listToReturn, technician];
    }
  }
  return listToReturn;
};

export const UpdateTechnician = ({ technicianList, current, Success }) => {
  const { snackbarHandler } = useContext(AuthContext);
  const { InputGroup } = SimpleForm;

  const { popupHeight } = useWindowSize();

  const [filterBy, setFilterBy] = useState("");
  const [technician, setTechnician] = useState(technicianList);

  const [isLoading, setIsLoading] = useState(true);
  const [reloadTechnician, setReloadTechnician] = useState(true);
  const [selectedTechnician, setSelectedTechnician] = useState([]);

  const filterByNameEmailHandler = (event) => setFilterBy(event.target.value);

  // get selected technician
  useEffect(() => {
    let isMounted = true;
    if (reloadTechnician) {
      let params = {
        routeId: current.id,
      };
      get("routes/technicians/list", params)
        .then((technician) => {
          if (isMounted) {
            setSelectedTechnician(technician);
            setReloadTechnician(false);
            setIsLoading(false);
          }
        })
        .catch((status) => {
          snackbarHandler(getTranslation(`error${status}`));
          setReloadTechnician(false);
          setIsLoading(false);
          Log("Error: get routes/technicians/list" + status);
        });
    }
    return () => (isMounted = false);
  }, [reloadTechnician, current, snackbarHandler]);

  useEffect(() => {
    if (selectedTechnician) {
      let list = filterSelectedTechnician(technicianList, selectedTechnician);
      if (filterBy !== "") {
        list = list.filter((account) => {
          let accountName = account.name ? account.name.toUpperCase() : "";
          let accountEmail = account.email ? account.email.toUpperCase() : "";
          let items = accountName.includes(filterBy.toUpperCase());
          if (!items) {
            items = accountEmail.includes(filterBy.toUpperCase());
          }
          return items;
        });
      }
      setIsLoading(false);
      setTechnician(list);
    }
  }, [selectedTechnician, technicianList, filterBy]);

  const removeTechnicianClickHandler = (id) => {
    setIsLoading(true);
    let params = {
      id,
    };
    del("routes/technicians", params)
      .then(() => {
        setReloadTechnician(true);
        Success();
      })
      .catch((status) => {
        setIsLoading(false);
        snackbarHandler(getTranslation(`error${status}`));
        Log("Error: delete routes/technicians" + status);
      });
  };

  const addTechnicianClickHandler = (id) => {
    setIsLoading(true);
    let toSend = {
      routeId: current.id,
      accountId: id,
    };
    post("routes/technicians", toSend)
      .then(() => {
        setReloadTechnician(true);
        Success();
      })
      .catch((status) => {
        setIsLoading(false);
        snackbarHandler(getTranslation(`error${status}`));
        Log("Error: create routes/technicians" + status);
      });
  };

  return (
    <BodyWrapperStyled>
      <BoxStyled width="xs" col="2" fullHeight>
        <CardStyled>
          <CardHeader>
            <FilterListOutlinedIcon className="mainIcon" />
            <div className="detail" data-translate="0076">
              {getTranslation("0076")}
              <span data-translate="0049,0077">
                {ReplaceWord(
                  getTranslation("0077"),
                  "**LIST**",
                  getTranslation("0049").toLowerCase()
                )}
              </span>
            </div>
          </CardHeader>
          <CardBody height={popupHeight}>
            <div className="outline md" style={{ padding: 10 }}>
              <InputGroup
                name="filterBy"
                placeholder={`${getTranslation("0050")}/${getTranslation(
                  "0002"
                )}`}
                inputElement={{
                  onChange: filterByNameEmailHandler,
                  name: "filterBy",
                  type: "text",
                }}
              />
            </div>
          </CardBody>
        </CardStyled>
      </BoxStyled>
      <BoxStyled width="xl" col="2" fullHeight>
        <BodyWrapperStyled>
          <BoxStyled width="md" col="2" noMargin>
            <CardStyled>
              <CardHeader>
                <PeopleAltIcon className="mainIcon" />
                <div className="detail" data-translate="0049">
                  {getTranslation("0049")}s
                  <span data-translate="0078,0088">
                    {ReplaceWord(
                      getTranslation("0078"),
                      "**NUMBER**",
                      technician.length,
                      "**LISTNAME**",
                      getTranslation("0088").toLowerCase() + "s"
                    )}
                  </span>
                </div>
              </CardHeader>
              <CardBody height={popupHeight} position={isLoading}>
                {isLoading && <InProgress />}
                {technician.length > 0 &&
                  !isLoading &&
                  technician.map((account, index) => (
                    <AccountDetail
                      key={index}
                      account={account}
                      Add={addTechnicianClickHandler}
                    />
                  ))}
              </CardBody>
            </CardStyled>
          </BoxStyled>
          <BoxStyled width="md" col="2" noMargin fullHeight>
            <CardStyled>
              <CardHeader>
                <CheckIcon className="mainIcon" />
                <div className="detail" data-translate="0137">
                  {getTranslation("0137")}
                  <span data-translate="0141">
                    {getTranslation("0141") &&
                      ReplaceWord(
                        getTranslation("0141"),
                        "**NUMBER**",
                        selectedTechnician.length
                      )}
                  </span>
                </div>
              </CardHeader>
              <CardBody height={popupHeight} position={isLoading}>
                {isLoading && <InProgress />}
                {selectedTechnician.length > 0 &&
                  !isLoading &&
                  selectedTechnician.map((account, index) => (
                    <AccountDetail
                      key={index}
                      account={account}
                      isTechnician
                      Remove={removeTechnicianClickHandler}
                    />
                  ))}
              </CardBody>
            </CardStyled>
          </BoxStyled>
        </BodyWrapperStyled>
      </BoxStyled>
    </BodyWrapperStyled>
  );
};
